<script>
import ScrollPane from './scrollPane'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  data () {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {}
    }
  },
  computed: {
    visitedViews () {
      return this.$store.state.tagsView.visitedViews
    }
  },
  watch: {
    $route () {
      this.addViewTags()
      this.moveToCurrentTag()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
    this.addViewTags()
  },
  methods: {
    // generateTitle, // generateTitle by vue-i18n
    generateRoute () {
      if (this.$route.name) {
        return this.$route
      }
      return false
    },
    isActive (route) {
      return route.path === this.$route.path || route.name === this.$route.name
    },
    addViewTags () {
      const route = this.generateRoute()
      if (!route) return false
      else if (route.path && route.path === '/') return false
      this.$store.dispatch('addVisitedViews', route)
    },
    moveToCurrentTag () {
      // console.log('refs', this.$refs.tag)
      if (this.$refs.tag !== undefined) {
        const tags = this.$refs.tag
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag.$el)
              break
            }
          }
        })
      }
    },
    closeSelectedTag (view) {
      if (view.name === 'home') {
        this.$message.error('A aba Home não pode ser fechada!')
      } else {
        this.$store.dispatch('delVisitedViews', view).then(views => {
          if (this.isActive(view)) {
            const latestView = views.slice(-1)[0]
            if (latestView) {
              this.$router.push(latestView.path)
            } else {
              this.$router.push('/')
            }
          }
        })
      }
    },
    closeOthersTags () {
      this.$router.push(this.selectedTag.path)
      this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags () {
      this.$store.dispatch('delAllViews')
      this.$router.push('/')
    },
    openMenu (tag, e) {
      this.visible = true
      this.selectedTag = tag
      this.left = e.clientX
      this.top = e.clientY
    },
    closeMenu () {
      this.visible = false
    }
  }
}
</script>

<template>
  <div class="tags-view-container">
    <scroll-pane class="tags-view-wrapper" ref="scrollPane">
      <router-link
        ref="tag"
        class="tags-view-item"
        :class="isActive(tag)?'active':''"
        v-for="tag in Array.from(visitedViews)"
        :to="tag.path"
        :key="tag.path"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        <i :class="tag.icon"></i>
        {{tag.title}}
        <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></span>
      </router-link>
    </scroll-pane>
    <ul class="contextmenu" v-show="visible" :style="{left:left+'px',top:top+'px'}">
      <li style="text-align: left;" @click="closeSelectedTag(selectedTag)">
        <i class="far fa-times-circle"></i> Fechar
      </li>
      <li style="text-align: left;" @click="closeOthersTags()">
        <i class="far fa-times-circle"></i> Fechar Outros
      </li>
      <li style="text-align: left;" @click="closeAllTags">
        <i class="far fa-times-circle"></i> Fechar Todos
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
  .tags-view-container {
    margin-top: 5px;
    .tags-view-wrapper {
      background: ghostwhite;
      background: ghostwhite;
      height: 34px;
      border-bottom: 1px solid #d8dce5;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
      .tags-view-item {
        text-decoration: none !important;
        display: inline-block;
        position: relative;
        height: 26px;
        line-height: 26px;
        border: 1px solid #d8dce5;
        color: #495060;
        background: #fff;
        padding: 0 8px;
        font-size: 12px;
        margin-left: 5px;
        margin-top: 4px; //original
        margin-top: 9px;
        &:first-of-type {
          margin-left: 11px;
        }
        &.active {
          background-color: #42b983;
          background-color: var(--fs-tag-color);
          color: #fff;
          border-color: var(--fs-tag-color);
          &::before {
            content: '';
            background: #fff;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
          }
        }
      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 2;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>
